import { Fragment, useContext, useRef, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { Grid } from "@mui/material";
import { LocaleContext } from "../../../routing/LangRouter.js";

//import general components
import BaseTextField from "../../common/base-text-field/base-text-field.jsx";
import AutoCompleteComponent from "../../common/base-select/autocomplete-component.js.jsx";
import SingleDatePicker from "../../common/single-date-picker/single-date-picker.jsx";

function HotelPassengerForm({
    children,
    fieldList,
    roomIndex,
    formIndex,
    IDcard,
    registerOptions,
    control,
    register,
    getValues,
    errors,
    nestedName,
}) {
    const inputRef = useRef(null);
    const [searchValue, setSearchValue] = useState("");
    const { locale } = useContext(LocaleContext);
    const [isFocused, setIsFocused] = useState([{}]);

    return (
        <Grid container item xs={12} rowGap={3} columnGap={4}>
            {fieldList
                .sort((a, b) => a.id - b.id)
                .map(field => {
                    return (
                        <Fragment key={field.id}>
                            {IDcard?.[formIndex]?.[field?.condition] || field?.condition === "always" ? (
                                <>
                                    {field.type === "input" && (
                                        <Grid container item md={2.8} lg={2.7}>
                                            <BaseTextField
                                                dir={field.dir}
                                                label={field.label}
                                                radius="10px"
                                                name={`${nestedName}passengers.${formIndex}.${field.name}`}
                                                type={field.fieldType}
                                                focused={
                                                    !!getValues(`${nestedName}passengers.${formIndex}.${field.name}`) ||
                                                    isFocused?.[formIndex]?.[field.name]
                                                }
                                                onFocus={() =>
                                                    setIsFocused(prev => {
                                                        const newState = [...prev];
                                                        if (!newState[formIndex]) newState[formIndex] = {};
                                                        newState[formIndex][field.name] = true;
                                                        return newState;
                                                    })
                                                }
                                                register={{
                                                    ...register(`${nestedName}passengers.${formIndex}.${field.name}`, registerOptions?.[field.name]),
                                                }}
                                                error={
                                                    errors?.passengers?.[formIndex]?.[field.name]?.message ||
                                                    errors?.rooms?.[roomIndex]?.passengers?.[formIndex]?.[field.name]?.message
                                                }
                                            />
                                        </Grid>
                                    )}
                                    {field.type === "select" && (
                                        <Grid container item md={2.8} lg={2.7}>
                                            <AutoCompleteComponent
                                                dir={field.dir}
                                                width="auto"
                                                label={field.label}
                                                options={field.options}
                                                name={`${nestedName}passengers.${formIndex}.${field.name}`}
                                                defaultValue={getValues(`${nestedName}passengers.${formIndex}.${field.name}`)}
                                                setInputValue={field?.setInputValue || setSearchValue}
                                                control={control}
                                                register={registerOptions?.[field.name]}
                                                errors={
                                                    errors?.passengers?.[formIndex]?.[field.name]?.message ||
                                                    errors?.rooms?.[roomIndex]?.passengers?.[formIndex]?.[field.name]?.message
                                                }
                                                focused={
                                                    !!getValues(`${nestedName}passengers.${formIndex}.${field.name}`) ||
                                                    isFocused?.[formIndex]?.[field.name]
                                                }
                                                onFocus={() =>
                                                    setIsFocused(prev => {
                                                        const newState = [...prev];
                                                        if (!newState[formIndex]) newState[formIndex] = {};
                                                        newState[formIndex][field.name] = true;
                                                        return newState;
                                                    })
                                                }
                                            />
                                        </Grid>
                                    )}
                                    {field.type === "date" && (
                                        <Grid container item md={2.8} lg={2.7}>
                                            <SingleDatePicker
                                                dir={field.dir}
                                                label={field.label}
                                                name={`${nestedName}passengers.${formIndex}.${field.name}`}
                                                size="medium"
                                                isPersianCalendar={field?.isPersianCalendar && locale === "fa"}
                                                defaultValue={
                                                    getValues(`${nestedName}passengers.${formIndex}.${field.name}`)
                                                        ? new DateObject(new Date(getValues(`${nestedName}passengers.${formIndex}.${field.name}`)))
                                                        : null
                                                }
                                                minDate={field?.minDate}
                                                maxDate={field?.maxDate}
                                                format="YYYY/MM/DD"
                                                control={control}
                                                register={registerOptions[field.name]}
                                                errors={
                                                    errors?.passengers?.[formIndex]?.[field.name]?.message ||
                                                    errors?.rooms?.[roomIndex]?.passengers?.[formIndex]?.[field.name]?.message
                                                }
                                            />
                                        </Grid>
                                    )}
                                    {field.type === "popover" && (
                                        <Grid container item md={2.8} lg={2.7}>
                                            {children}
                                        </Grid>
                                    )}
                                </>
                            ) : null}
                        </Fragment>
                    );
                })}
        </Grid>
    );
}

export default HotelPassengerForm;
